import { render, staticRenderFns } from "./manage-profile.vue?vue&type=template&id=994baa72&scoped=true"
import script from "./manage-profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-profile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-profile.vue?vue&type=style&index=0&id=994baa72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994baa72",
  null
  
)

export default component.exports